import React from 'react'
import Toast from '@/components/ui/toast'
import { toast } from 'react-toastify'
import CrossIcon from '@/assets/icons/cross'
import ButtonIcon from '@/components/ui/ButtonIcon'
import { i18n } from '@/locale/i18n'
// import Device from 'common/util/Device'

export const toastService = (type, data, customOptions) => {
  const options = {
    hideProgressBar: true,
    autoClose: 2000,
    closeOnClick: true,
    position: 'top-right',
    pauseOnHover: true,
    draggable: true,
    newestOnTop: true,
    progress: undefined,
    closeButton: ({ closeToast }) => (
      <ButtonIcon
        variant="normal"
        size="small"
        cursorPointer
        highlightOnHover
        handleOnClick={closeToast}
        ariaLabel={i18n('common.close')}>
        <CrossIcon />
      </ButtonIcon>
    ),
    icon: false,
    theme: localStorage.getItem('theme') || 'light',
    ...customOptions, 
  }

  const toastContent = <Toast component={type} _data={data} className={type} />

  toast(toastContent, options)
}
